import {
  IntegrationChannelType,
  IntegrationType,
  IntegrationViewFragment,
} from 'generated/graphql';

interface GetIsCohortIntegrationAlreadyConnectedParams {
  connectedIntegrations: IntegrationViewFragment[];
  channelType: IntegrationChannelType;
}

export const getIsCohortIntegrationAlreadyConnected = ({
  connectedIntegrations,
  channelType,
}: GetIsCohortIntegrationAlreadyConnectedParams) => {
  const activeCohortIntegrations = connectedIntegrations.filter(
    (integration) =>
      integration.integrationType === IntegrationType.Cohorts &&
      integration.isActive,
  );

  return Boolean(
    activeCohortIntegrations.find(
      (integration) => integration.channel.type === channelType,
    ),
  );
};
